module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-touch', {
    staticClass: "answers answersslideshow",
    attrs: {
      "tag": "div"
    },
    on: {
      "swipeleft": function($event) {
        (_vm.current < _vm.answers.length - 1) ? _vm.current++ : _vm.current = _vm.current
      },
      "swiperight": function($event) {
        (_vm.current > 0) ? _vm.current-- : _vm.current = _vm.current
      }
    }
  }, [_c('transition-group', {
    staticClass: "answer-cards",
    attrs: {
      "id": "answer-cards",
      "name": "staggered-fade",
      "tag": "ul",
      "css": false,
      "mode": "in-out"
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.answers), function(answer, index) {
    return (_vm.current === index) ? _c('li', {
      key: index,
      staticClass: "answer-card",
      class: {
        'correct': answer.points
      }
    }, [_c('div', {
      staticClass: "ac-question"
    }, [_vm._v(_vm._s(answer.question))]), _vm._v(" "), _c('div', {
      staticClass: "answer"
    }, [_vm._v("Jij zei: "), _c('span', [_vm._v(_vm._s(answer.answer))]), _c('span', {
      staticClass: "points"
    }, [_vm._v(_vm._s(answer.points) + " punten")])])]) : _vm._e()
  })), _vm._v(" "), _c('span', {
    staticClass: "slideshow-button prev",
    on: {
      "click": function($event) {
        (_vm.current > 0) ? _vm.current-- : _vm.current = _vm.current
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slideshow-button next",
    on: {
      "click": function($event) {
        (_vm.current < _vm.answers.length - 1) ? _vm.current++ : _vm.current = _vm.current
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41767f7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnswersSlideshow.vue
// module id = 116
// module chunks = 1